import React, { useEffect, useState,useCallback} from "react";
import { Button, Col, Container, Row, TextInput } from "react-materialize";
import LoadingView from "../loading/loading.view";
import Modal from "./modal";
import Swal from 'sweetalert2';
import { ErpConnect as qad } from '../../../services/index.js';


const ModalCambioPrecios = ({
  isOpen,
  onClose,
  solicitud,
  loading = false
}) => {

  const [items, setItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);
  const [creandoPedido, setCreandoPedido] = useState(false);
  const [mostrarPrecioMasivo, setMostrarPrecioMasivo] = useState(false);
  const [precioMasivo, setPrecioMasivo] = useState("");
  const todosMarcados = items.length > 0 && items.every(item => item.usarNuevoPrecio);

  const handleCloseModal = () => {
    if (typeof onClose === "function") onClose();
  };

  const handleChangePrecio = (id, value) => {
    setItems(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, new_price: value }
          : item
      )
    );
  };

 

  const obtenerExistencias = async (productId, siteBuscado) => {
    const res = await fetch(
      `http://miplayera2.dyndns.org:8810/gmpPlatforms/rest/inventories/read?id=${productId}`
    );
    const data = await res.json();
    const inventarios = data?.read?.[0]?.data ?? [];
    console.log(inventarios
      .filter(item => item.site === String(siteBuscado))
      .map(item => ({
        site: item.site,
        stock: Number(item.stock)
      })));
    return inventarios
      .filter(item => item.site === String(siteBuscado))
      .map(item => ({
        site: item.site,
        stock: Number(item.stock)
      }));
  };
  const handleTogglePrecio = (id) => {
    setItems(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, usarNuevoPrecio: !item.usarNuevoPrecio }
          : item
      )
    );
  };

  const aplicarPrecioMasivo = () => {
    setItems((prevItems) =>
      prevItems.map((item) =>
        item.usarNuevoPrecio
          ? { ...item, new_price: precioMasivo }
          : item
      )
    );
  };
  const handleToggleTodos = (checked) => {
    setItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        usarNuevoPrecio: checked
      }))
    );
  };
const cancelarSolicitud = async () => {

  try {

    const confirmacion = await Swal.fire({
      icon: "warning",
      title: "Cancelar solicitud",
      text: "¿Seguro que deseas cancelar esta solicitud?",
      showCancelButton: true,
      confirmButtonText: "Sí, cancelar",
      cancelButtonText: "No"
    });

    if (!confirmacion.isConfirmed) return;

    setCreandoPedido(true);

    Swal.fire({
      title: "Cancelando solicitud...",
      text: "Por favor espera",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    const response = await fetch("/api/cart-price-request/complete", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        request_id: solicitud.id,
        erp_response: "Cancelado manualmente",
        is_cancelled: true
      })
    });

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || "No se pudo cancelar");
    }

    Swal.fire({
      icon: "success",
      title: "Solicitud cancelada"
    });

   // await cargarPendientes();

  } catch (err) {

    console.error(err);

    Swal.fire({
      icon: "error",
      title: "Error",
      text: err.message
    });

  } finally {

    setCreandoPedido(false);
    handleCloseModal();

  }
};
const fetchCartItems = useCallback(async (cartId, siteSolicitud) => {
  try {
    setLoadingItems(true);

    const res = await fetch(`/api/cart-price-request/${cartId}/items`);
    const data = await res.json();
    
    const itemsConInventario = await Promise.all(
      data.map(async item => {
        const existencias = await obtenerExistencias(item.product_id, siteSolicitud);

        return {
          ...item,
          cve_prod: item.product_id,
          codigo: item.product_id,
          desc_prod: item.descripcion,
          talla: item.size,
          cantidad: item.quantity,
          prec_prod: item.new_price || item.price,
          usarNuevoPrecio: false, 
          existencias,
          cse_prod: "PRODUCTO"
        };
      })
    );

    setItems(itemsConInventario);

  } catch (err) {
    console.error("Error cargando items:", err);
  } finally {
    setLoadingItems(false);
  }
}, []); 
  const crearPedidoDesdeSolicitud = async () => {

    try {

      if (!items.length) return;

     
      const siteId = solicitud?.site;
      const clientId = solicitud?.client_id;
      const salesPersonId = solicitud?.requested_by;

      if (!clientId) {
        Swal.fire({
          icon: "error",
          title: "Cliente inválido"
        });
        return;
      }

      for (const item of items) {

        const precioFinal = item.usarNuevoPrecio
          ? item.new_price
          : item.price;

        if (!parseFloat(precioFinal)) {
          Swal.fire({
            icon: "warning",
            title: "Precio inválido",
            text: `Producto ${item.product_id} sin precio válido`
          });
          return;
        }

        const existencias = item.existencias || [];

        const totalStock = existencias.reduce(
          (acc, curr) => acc + Number(curr.stock || 0),
          0
        );

        if (Number(item.quantity) > totalStock) {
          Swal.fire({
            icon: "error",
            title: "Sin existencia",
            text: `Stock insuficiente para ${item.product_id}`
          });
          return;
        }
      }

      const formattedOrder = {
        customerId: clientId,
        shippingAddressId: clientId,
        siteId: String(siteId),
        remarks: solicitud?.comments,
        salesPersonId,
        source: "PV",
        appId: "N/A",
        lines: items.map(item => ({
          customerId: clientId,
          productId: item.product_id,
          quantity: String(item.quantity),
          price: String(
            item.usarNuevoPrecio
              ? item.new_price
              : item.price
          )
        }))
      };

      setCreandoPedido(true);
      Swal.fire({
        title: "Creando pedido...",
        text: "Por favor espera",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading()
      });
      await new Promise(resolve => setTimeout(resolve, 3000));

      const orderCreated = await qad.catalog.salesOrder.create(formattedOrder);

      if (!orderCreated?.salesOrderId) {
        Swal.fire({
          icon: "error",
          title: "No se pudo crear el pedido"
        });
        return;
      }

      await qad.catalog.salesOrder.toRemision(orderCreated.salesOrderId);

      Swal.fire({
        icon: "success",
        title: "Pedido creado",
        text: `Pedido ${orderCreated.salesOrderId}`
      });
    
      await fetch("/api/cart-price-request/complete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          request_id: solicitud.id,         
          erp_response: orderCreated.salesOrderId,
          items: items.map(item => ({
            product_id: item.product_id,
            new_price: item.usarNuevoPrecio
              ? item.new_price
              : item.price
          }))
        })
      });
    } catch (err) {

      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message
      });

    } finally {
      setCreandoPedido(false);
      handleCloseModal();
    }

  };

  useEffect(() => {
    if (isOpen && solicitud?.id) {
      fetchCartItems(solicitud.id, solicitud.site);
    }
  }, [isOpen, solicitud,fetchCartItems]);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={handleCloseModal} title="Cambio de precios">
      <Container>

        {loading ? (
          <LoadingView />
        ) : solicitud ? (
          <>
            <Row className="mb-3">
              <Col s={12}>
                <h4>Solicitud Cambio de Precios</h4>
              </Col>
            </Row>
            <br></br>
            <Row className="mb-3">
              <Col s={12}>
                <TextInput
                  label="Solicitado por"
                  value={solicitud.requested_name || ""}
                  readOnly
                />
              </Col>
            </Row>

            <Row>
              <Col s={12}>
                <h5 style={{ marginBottom: 25 }}>Productos del Carrito</h5>
             <Row className="mb-3" style={{ alignItems: "flex-end" }}>
  
              <Col s={12} m={4}>
                <Button onClick={() => setMostrarPrecioMasivo(!mostrarPrecioMasivo)}>
                  Precio masivo
                </Button>
              </Col>

              {mostrarPrecioMasivo && (
                <>
                  <Col s={12} m={3}>
                    <TextInput
                      label="Precio"
                      value={precioMasivo}
                      onChange={(e) => setPrecioMasivo(e.target.value)}
                    />
                  </Col>

                  <Col s={12} m={2}>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <input
                        type="checkbox"
                        checked={todosMarcados}
                        onChange={(e) => handleToggleTodos(e.target.checked)}
                      />
                      <span>Marcar todos</span>
                    </label>
                  </Col>

                  <Col s={12} m={2}>
                    <Button onClick={aplicarPrecioMasivo}>
                      Confirmar
                    </Button>
                  </Col>
                </>
              )}
            </Row>
            
              </Col>

            </Row>
          <br></br>
            {loadingItems ? (
              <LoadingView />
            ) : items.length === 0 ? (
              <p>No hay productos</p>
            ) : (
              items.map((item) => (
                <Row key={item.id} className="mb-2">
                  <Col s={12} m={2}>
                    <TextInput label="Producto" value={item.product_id} readOnly />
                  </Col>

                  <Col s={12} m={2}>
                    <TextInput label="Descripción" value={item.descripcion} readOnly />
                  </Col>

                  <Col s={12} m={1}>
                    <TextInput label="Cantidad" value={String(item.quantity)} readOnly />
                  </Col>

                  <Col s={12} m={1}>
                    <TextInput label="Talla" value={item.size || ""} readOnly />
                  </Col>

                  <Col s={12} m={2}>
                    <TextInput label="Color" value={item.color || ""} readOnly />
                  </Col>
                  
                  <Col s={12} m={1}>
                    <TextInput label="Actual" value={item.price} readOnly />
                  </Col>
                  
                 

                  <Col s={12} m={2}>
                    <TextInput
                      label="Nuevo"
                      value={item.new_price ?? ""}
                      readOnly={!item.usarNuevoPrecio}
                      onChange={(e) => handleChangePrecio(item.id, e.target.value)}
                    />
                  </Col>
                   <Col s={12} m={1}>
                    <label>
                      <input
                        type="checkbox"
                        checked={item.usarNuevoPrecio}
                        onChange={() => handleTogglePrecio(item.id)}
                      />
                      <span></span>
                    </label>
                  </Col>
                </Row>
              ))
            )}
         <Row>

          <Col s={12}  >
            <div style={{ margin: 25,display: "flex", gap: "10px", justifyContent: "flex-start" }}>
              
              <Button
              
                onClick={crearPedidoDesdeSolicitud}
                disabled={creandoPedido}
              >
                {creandoPedido ? "Enviando..." : "Colocar Pedido"}
              </Button>

              <Button
                node="button"
                onClick={cancelarSolicitud}
                disabled={creandoPedido}
                className="btn-cancelar"
              >
                {creandoPedido ? "Cancelando..." : "Cancelar Solicitud"}
              </Button>

            </div>
          </Col>
        </Row>

          </>
        ) : (
          <p>No hay información</p>
        )}

      </Container>
    </Modal>
  );
};

export default ModalCambioPrecios;